import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slike from "../../komponente/Pocetna/Slike";
import WrapperSidebar from "../../komponente/WrapperSidebar";
import VestiWidget from "../../komponente/Widgets/VestiWidget";
import apiEndpoint from "../../test/config";
import LinkoviWidget from "../../komponente/Widgets/LinkoviWidget";
import Slike2 from "../../komponente/Pocetna/Slike2";
import pozicijeSlika from "../../test/pozicije";
import WSPGallery from "../../komponente/EksterneKomponente/WSPGallery";
// import VestiStranica from "./VestiStranica";

type ContentBlock =
    | { type: 'html'; content: string }
    | { type: 'gallery'; images: { img: string }[]; columns: number };

// WordPress u klasi galerije šalje broj kolona iz editora:
// klasična galerija -> "gallery-columns-3", blok galerija -> "columns-3" ("columns-default" = 3)
function brojKolonaGalerije(gal: Element): number {
    const m = (gal.getAttribute('class') || '').match(/(?:^|\s)(?:gallery-)?columns-(\d+)/);
    const n = m ? parseInt(m[1], 10) : 3;
    return Math.min(Math.max(n || 3, 1), 6);
}

function obradiTeloVesti(htmlText: string): ContentBlock[] {
    if (!htmlText) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');

    const styleTags = doc.querySelectorAll('style');
    styleTags.forEach((style) => style.remove());

    const galleries = doc.querySelectorAll('.gallery, .wp-block-gallery');

    if (galleries.length === 0) {
        return [{ type: 'html', content: doc.body.innerHTML }];
    }

    const galleryData: { images: { img: string }[]; columns: number }[] = [];

    galleries.forEach((gal) => {
        const images: { img: string }[] = [];
        const imgElements = gal.querySelectorAll('img');

        imgElements.forEach((img) => {
            const parentA = img.closest('a');
            const href = parentA ? parentA.getAttribute('href') : null;
            const src = img.getAttribute('src');

            let finalUrl = src;
            if (href && /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(href)) {
                finalUrl = href;
            }

            if (finalUrl && !images.some((item) => item.img === finalUrl)) {
                images.push({ img: finalUrl });
            }
        });

        if (images.length > 0) {
            galleryData.push({ images, columns: brojKolonaGalerije(gal) });
            const placeholder = doc.createElement('div');
            placeholder.setAttribute('data-wsp-gallery-id', (galleryData.length - 1).toString());
            gal.parentNode?.replaceChild(placeholder, gal);
        } else {
            gal.remove();
        }
    });

    const fullHtml = doc.body.innerHTML;
    const parts = fullHtml.split(/<div data-wsp-gallery-id="(\d+)"><\/div>/gi);

    const blocks: ContentBlock[] = [];
    for (let i = 0; i < parts.length; i++) {
        if (i % 2 === 0) {
            if (parts[i].trim()) {
                blocks.push({ type: 'html', content: parts[i] });
            }
        } else {
            const gIndex = parseInt(parts[i], 10);
            if (galleryData[gIndex] && galleryData[gIndex].images.length > 0) {
                blocks.push({ type: 'gallery', images: galleryData[gIndex].images, columns: galleryData[gIndex].columns });
            }
        }
    }

    return blocks;
}

function VestStranica() {
    let { slug } = useParams()
    // console.log(slug)

    const query = `{
    vestBy(id: "${slug}") {
        acf {
        naslov
        podnaslov
        datumobjave
        fieldGroupName
        zoomdirection
        opcijenaslova
        telovesti
        thumbnail {
          sourceUrl
        }
        shadow
        slikanamobilnom {
            sourceUrl
        }
        drugaslika
      }
      date
    }
    }`

    // console.log(query)
    // console.log(test)

    const dataToVesti = (data) => {
        let opcijeNaslova = data['acf']['opcijenaslova'] == null ? ['levo'] : data['acf']['opcijenaslova']
        let velNaslova = opcijeNaslova.includes('velikaslova') ? 2 : opcijeNaslova.includes('srednjaslova') ? 1 : 0
        let pozNaslova = opcijeNaslova.includes('levo') ? 0 : opcijeNaslova.includes('desno') ? 2 : opcijeNaslova.includes('centar') ? 1 : 0

        let acf = data['acf']
        let vestiArr = {
            zatamljenje: acf['shadow'] == null ? false : true,
            mobUrl: acf['drugaslika'] ? (acf['slikanamobilnom'] == null ? null : acf['slikanamobilnom']['sourceUrl']) : null,
            naslov: acf['naslov'],
            podnaslov: acf['podnaslov'],
            tekstBlokovi: obradiTeloVesti(acf['telovesti']),
            pozSlika: pozicijeSlika[acf["zoomdirection"]],
            slika: acf['thumbnail']['sourceUrl'],
            velNaslova: velNaslova,
            pozNaslova: pozNaslova,
            datum: acf['datumobjave'] == null ? data["date"].match(/\d{4}-\d{2}-\d{2}/)[0].split("-").reverse().join(".") : acf['datumobjave'].split("/").join(".")
        }
        setVest(vestiArr)
        setVestiB(true)
    }
    const [vest, setVest] = useState<any>({})
    const [vestiB, setVestiB] = useState(false)
    useEffect(() => {
        fetch(apiEndpoint,
            {
                method: 'POST',
                headers: {
                    "Content-Type": 'application/json',
                    "Accept": 'application/json'
                },
                body: JSON.stringify({
                    query
                })
            }).then((response) => response.json()).then((data) => dataToVesti(data['data']['vestBy']));
    }, []);

    const [widgets, setWidgets] = useState([])
    useEffect(() => {
        fetch(apiEndpoint, {
            method: 'POST', headers: { "Content-Type": 'application/json', "Accept": 'application/json' },
            body: JSON.stringify({
                query: `{pages(where: {name: "SideBar"}) {nodes {sidebar {
                    vesti
                }}}}` })
        }).then((response) => response.json()).then((data) => {
            setWidgets(data['data']['pages']['nodes'][0]['sidebar']['vesti'])
        });
        window.scrollTo(0, 0);
    }, []);
    let slika = [
        {
            zatamljenje: vest['zatamljenje'],
            mobUrl: vest['mobUrl'],
            redniBroj: 0,
            naslov: vest['naslov'],
            opis: vest['podnaslov'],
            velNaslova: vest['velNaslova'],
            pozNaslova: vest['pozNaslova'],
            link_strane: '',
            url: vest['slika'],
        }
    ]

    const mesec = (datum) => {
        switch (datum) {
            case '01':
                return 'Јануар'
            case '02':
                return 'Фебруар'
            case '03':
                return 'Март'
            case '04':
                return 'Април'
            case '05':
                return 'Мај'
            case '06':
                return 'Јун'
            case '07':
                return 'Јул'
            case '08':
                return 'Август'
            case '09':
                return 'Септембар'
            case '10':
                return 'Октобар'
            case '11':
                return 'Новембар'
            default:
                return 'Децембар'
        }
    }

    return <>
        <Slike2 slike={slika}></Slike2>
        <div className="devider100"></div>
        <WrapperSidebar element={<>
            <div className="vest-wrapper">
                {vestiB && <>
                    <h1>{vest['naslov']}</h1>
                    <div className="kategorija-datum">
                        {/* <div className="vl"></div> */}
                        <div className="datum">
                            <h3>{vest['datum'].substring(0, 2) + '. ' + mesec(vest['datum'].substring(3, 5)) + ' ' + vest['datum'].substring(6, 10) + '.'}</h3>
                        </div>
                    </div>
                    {vest['tekstBlokovi'] && vest['tekstBlokovi'].map((blok: ContentBlock, idx: number) => {
                        if (blok.type === 'gallery') {
                            return (
                                <div key={idx} style={{ margin: '20px 0' }}>
                                    <WSPGallery galleryImages={blok.images} columns={blok.columns} />
                                </div>
                            );
                        }
                        return (
                            <div
                                key={idx}
                                className="tekst"
                                dangerouslySetInnerHTML={{ __html: blok.content }}
                            ></div>
                        );
                    })}
                </>}
            </div>
        </>} vl_slide={true} widgets={widgets}></WrapperSidebar>
    </>

}

export default VestStranica